import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'

const Index = () => {
    return(
        <section className="not-found-section">
            <div className="inner-not-found-container">
                <h2 className="not-found-icon"><i class="fad fa-cat-space"/></h2>
                <h1 className="not-found-title">Kunne ikke finne siden</h1>
                <p className="not-found-description">Nå ser det ut som du har rotet deg bort, for denne siden eksisterer ikke. For å gå tilbake, trykk <Link to="/">her</Link>.</p>
            </div>
        </section>
    )
}

export default Index